import Vue from "vue";
import { getDefaultState } from "./state";
import { useSettingsStore } from "@/stores/settings";

/**
 *  Mutations for the sections/classes store
 *@module Sections
 * @category Store
 * @subcategory Sections
 * @name Mutations
 */

export default {
  /**
   * Reset state to default empty state
   * @param { object } state State
   */
  resetStateData: state => {
    Object.assign(state, getDefaultState());
  },

  loadMembersForSection: (state, payload) => {
    const settingsStore = useSettingsStore();

    if (payload.data.teachers && payload.data.teachers.teachers) {
      Vue.set(
        state.sectionsTeachersMap,
        payload.sectionId,
        payload.data.teachers.teachers.sort((a, b) => a.name.name.localeCompare(b.name.name, settingsStore.language))
      );
    }

    if (payload.data.students && payload.data.students.students) {
      Vue.set(
        state.sectionsStudentsMap,
        payload.sectionId,
        payload.data.students.students.sort((a, b) => a.name.name.localeCompare(b.name.name, settingsStore.language))
      );
    }
  },

  loadDrives: (state, { sectionId, rootDrive }) => {
    Vue.set(state.sectionRootDriveMap, sectionId, rootDrive);
  },

  loadSubdrives: (state, { driveId, driveItems }) => {
    Vue.set(state.sectionRootSubDrivesMap, driveId, driveItems);
  },

  addSectionToMySections: (state, section) => {
    state.mySectionsMap[section.sectionId] = section;
    const sect = Object.assign({}, state.mySectionsMap);
    Vue.set(state, "mySectionsMap", sect);
  },

  removeSectionFromMySections: (state, sectionId) => {
    delete state.mySectionsMap[sectionId];
    const sect = Object.assign({}, state.mySectionsMap);
    Vue.set(state, "mySectionsMap", sect);
  },

  sectionsLoadProfilePicturesFromList: (state, payload) => {
    payload.map(u => {
      if (u.status === 200) {
        var url = "data:" + u.headers["Content-Type"] + ";base64," + u.body;

        fetch(url).then(res =>
          res.blob().then(blob => {
            const url = window.URL.createObjectURL(blob);
            state.sectionsProfilePictures[u.id] = url;
          })
        );
      }
    });
  },

  sectionsLoadProfilePicture: (state, payload) => {
    state.sectionsProfilePictures[payload.extSysApiSectionId] = payload.url;
  },

  sectionsRemoveProfilePicture: (state, payload) => {
    delete state.sectionsProfilePictures[payload];
  }
};
